export const selectGuruWidget = state => state.guruWidget

export const selectGuruWidgetOpen = state => state.guruWidget.open

export const selectGuruWidgetView = state => state.guruWidget.view

export const selectGuruWidgetEntityAttachment = state => state.guruWidget.entityAttachment

export const selectGuruWidgetPrefilledInput = state => state.guruWidget.prefilledInput

export const selectGuruWidgetPosition = state => state.guruWidget.position

export const selectGuruOverrideScope = state => state.guruWidget.overrideScope
